import { ColDef } from 'ag-grid-community';
import { CellTypes } from '../../services/inventory';
import { Inventory } from '../../types/inventory';

interface InventoryColDef<T> extends ColDef<T> {
  type: keyof typeof CellTypes;
  field: any;
}

const toolTipValueGetter = (params: any) => {
  return 'Copy';
};

const columnDefs: InventoryColDef<Inventory>[] = [
  {
    headerName: 'Batch Number',
    field: 'batchNumber',
    sortable: true,
    width: 180,
    filter: 'agNumberColumnFilter',
    type: 'Plain',
    enableRowGroup: false,
  },
  {
    headerName: 'VIN',
    field: 'vin',
    sortable: true,
    width: 180,
    filter: 'agTextColumnFilter',
    type: 'Plain',
    enableRowGroup: false,
  },
  {
    headerName: 'Year',
    field: 'year',
    sortable: true,
    width: 100,
    filter: 'agTextColumnFilter',
    type: 'Plain',
    enableRowGroup: true,
  },
  {
    headerName: 'Model',
    field: 'model',
    sortable: true,
    type: 'Plain',
    width: 180,
    enableRowGroup: true,
  },
  {
    headerName: 'Variant',
    field: 'variant',
    sortable: true,
    type: 'Plain',
    width: 200,
    enableRowGroup: true,
  },
  {
    headerName: 'Vehicle Stage',
    field: 'vehicleStage',
    sortable: true,
    width: 170,
    type: 'Tag',
    enableRowGroup: true,
  },
  {
    headerName: 'Vehicle Substage',
    field: 'vehicleSubStage',
    sortable: true,
    type: 'Plain',
    width: 200,
    enableRowGroup: true,
  },
  {
    headerName: 'Current Country',
    field: 'transitCountry',
    sortable: true,
    type: 'Country',
    width: 160,
  },
  {
    headerName: 'Price',
    field: 'totalPrice',
    sortable: true,
    type: 'CurrencyDropDown',
    width: 220,
  },
  {
    headerName: 'Listing Country',
    field: 'listingCountry',
    sortable: true,
    type: 'Plain',
    width: 160,
  },
  {
    headerName: 'Homologation Country',
    field: 'country',
    sortable: true,
    type: 'Plain',
    width: 200,
    enableRowGroup: true,
  },
  {
    headerName: 'Customer Name',
    field: 'customerName',
    sortable: true,
    type: 'Plain',
    width: 200,
    enableRowGroup: true,
  },
  {
    headerName: '# of Factory Campaigns',
    field: 'numberOfCampaigns',
    sortable: true,
    type: 'Plain',
    width: 200,
    enableRowGroup: true,
  },
  {
    headerName: 'AMP1 Planned Broadcast Date',
    field: 'actualBroadcastDate',
    sortable: true,
    type: 'Plain',
    width: 200,
    enableRowGroup: true,
  },
  {
    headerName: 'AMP1 Actual Factory Gate Date',
    field: 'actualFactoryGateDate',
    sortable: true,
    type: 'Plain',
    width: 200,
    enableRowGroup: true,
  },
  {
    headerName: 'EU Port Date',
    field: 'euPortDate',
    sortable: true,
    type: 'Plain',
    width: 150,
    enableRowGroup: true,
    hide: false,
  },
  {
    headerName: 'AMP2 Actual Factory Gate Date',
    field: 'amp2ActualFactoryGateDate',
    sortable: true,
    type: 'Plain',
    width: 200,
    enableRowGroup: true,
  },
  {
    headerName: 'Exterior color',
    field: 'exteriorColor',
    sortable: true,
    type: 'Plain',
    width: 150,
    enableRowGroup: true,
  },
  {
    headerName: 'Interior color',
    field: 'interiorColor',
    sortable: true,
    type: 'Plain',
    width: 150,
    enableRowGroup: true,
  },
  {
    headerName: 'Look',
    field: 'look',
    sortable: true,
    type: 'Plain',
    width: 140,
    enableRowGroup: true,
  },
  {
    headerName: 'Roof',
    field: 'roof',
    sortable: true,
    type: 'Plain',
    width: 140,
    enableRowGroup: true,
  },
  {
    headerName: 'Drivetrain',
    field: 'driveTrain',
    sortable: true,
    type: 'Plain',
    width: 200,
    enableRowGroup: true,
  },
  {
    headerName: 'Wheels',
    field: 'wheels',
    sortable: true,
    type: 'Plain',
    width: 150,
    enableRowGroup: true,
  },
  {
    headerName: 'ADAS',
    field: 'ada',
    sortable: true,
    type: 'Plain',
    width: 140,
    enableRowGroup: true,
  },
  {
    headerName: 'Sound System',
    field: 'soundSystem',
    sortable: true,
    type: 'Plain',
    width: 180,
    enableRowGroup: true,
  },
  {
    headerName: 'Comfort & Convenience Package',
    field: 'lucidComfortAndConvenience',
    sortable: true,
    type: 'Plain',
    width: 200,
    enableRowGroup: true,
  },
  {
    headerName: 'Seats',
    field: 'lucidFrontSeating',
    sortable: true,
    type: 'Plain',
    width: 200,
    enableRowGroup: true,
  },
  {
    headerName: 'Suspension Damper',
    field: 'suspensionDamp',
    sortable: true,
    type: 'Plain',
    width: 200,
    enableRowGroup: true,
  },
  {
    headerName: 'Battery pack',
    field: 'batteryPack',
    sortable: true,
    type: 'Plain',
    width: 140,
    enableRowGroup: true,
  },
  {
    headerName: 'Current city',
    field: 'currentCity',
    sortable: true,
    type: 'Plain',
    width: 140,
    enableRowGroup: true,
  },
  {
    headerName: 'Current State',
    field: 'currentState',
    sortable: true,
    type: 'Plain',
    width: 140,
    enableRowGroup: true,
  },
  {
    headerName: 'In Transit To Location',
    field: 'inTransitToLocation',
    sortable: true,
    type: 'Plain',
    width: 140,
    hide: false,
    enableRowGroup: true,
  },
  {
    headerName: 'Title Status',
    field: 'titleStatus',
    sortable: true,
    type: 'Plain',
    width: 140,
    enableRowGroup: true,
  },
  {
    headerName: 'Link',
    field: 'weblink',
    sortable: false,
    type: 'Plain',
    width: 90,
    pinned: 'right',
    enableRowGroup: false,
    // tooltipField: 'weblink',
    // tooltipValueGetter: toolTipValueGetter,
    suppressFiltersToolPanel: true,
  },
  {
    headerName: 'Status',
    field: 'subCategory',
    sortable: true,
    type: 'Tag',
    width: 120,
    pinned: 'right',
    enableRowGroup: true,
  },
];

export const metaData = {
  _id: '6316fd3926673f830a4d64f7',
  module: 'Vehicles',
  subModule: 'Grid',
  columnDefs,
  filterDetails: [
    'Year',
    'Model',
    'Trim',
    'Variant',
    'Vehicle Stage',
    'Vehicle Substage',
    'Interior color',
    'Exterior color',
    'Wheels',
    'Battery pack',
    'Roof',
    'Drivetrain',
    'Price',
    'Suspension Damper',
    'ADAS',
    'Look',
    'Sound System',
    'Current City',
    'Current State',
    'Seats',
    'Comfort & Convenience Package',
    'Status',
    'Title Status',
  ],
  manageColumns: [
    'Year',
    'Model',
    'Trim',
    'Variant',
    'Vehicle Stage',
    'Vehicle Substage',
    'Interior color',
    'Exterior color',
    'Wheels',
    'Battery pack',
    'Roof',
    'Drivetrain',
    'Price',
    'Suspension Damper',
    'ADAS',
    'Look',
    'Sound System',
    'Current City',
    'Current State',
    'Seats',
    'Comfort & Convenience Package',
    'Title Status',
    'Status',
  ],
  langCode: 'en-us',
};
